if (!customElements.get("quantity-packs")) {
  customElements.define("quantity-packs", class extends HTMLElement {
    connectedCallback() {
      this.addEventListener("click", (event) => {
        const button = event.target.closest(".quantity-packs__button");
        if (!button) return;
        const input = this.closest(".product-info__quantity-selector")?.querySelector('input[name="quantity"]');
        if (!input) return;
        input.value = button.dataset.quantity;
        input.dispatchEvent(new Event("input", { bubbles: true }));
        input.dispatchEvent(new Event("change", { bubbles: true }));
        this.querySelectorAll(".quantity-packs__button").forEach((other) => {
          other.setAttribute("aria-pressed", other === button ? "true" : "false");
        });
      });
    }
  });
}
